import type { AxiosResponse } from 'axios';
import { httpWithAuth } from '~/clients';
import { SUGGESTED_FILTERS } from '~/constants/endpoints';
import type { InventoryRequest, SuggestedFilter } from '~/contracts/common';

type Request = InventoryRequest & { numberOfSuggestedFilters: number };

type Response = {
  suggestedFilters: SuggestedFilter[];
  suggestedFiltersRequestId: string;
};

export default function fetchSuggestedFilters(
  request: Request,
  controller: AbortController
): Promise<AxiosResponse<Response>> {
  return httpWithAuth.post<Response>(SUGGESTED_FILTERS, request, {
    signal: controller.signal
  });
}
